import { Injectable } from '@angular/core';

import { bensRoute } from "../../shared/data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { categoriasRoute } from "./data.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";

@Injectable()
export class CategoriaNavigationService {
  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = bensRoute + '/' + categoriasRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = bensRoute + '/' + categoriasRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = bensRoute + '/' + categoriasRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/shared/categoria-navigation.service.ts
 **/